import { render, staticRenderFns } from "./txtTab.vue?vue&type=template&id=c1a01870&scoped=true&"
import script from "./txtTab.vue?vue&type=script&lang=js&"
export * from "./txtTab.vue?vue&type=script&lang=js&"
import style0 from "./txtTab.vue?vue&type=style&index=0&id=c1a01870&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a01870",
  null
  
)

export default component.exports